var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { muiHelpOutline } from '@ally/metronome-icons';
import { Dejargonator } from '../../../../Dejargonator';
import { AdornmentIcon } from './AdornmentIcon';
export const AdornmentDejarg = (_a) => {
    var { heading, body, ariaLabelPopover } = _a, others = __rest(_a, ["heading", "body", "ariaLabelPopover"]);
    return (React.createElement(Dejargonator, { heading: heading, body: body, trigger: Object.assign({ variant: 'icon', content: React.createElement(AdornmentIcon, { icon: muiHelpOutline }) }, ('topic' in others
            ? { topic: others.topic }
            : { ariaLabel: others.ariaLabelTrigger })), ariaLabelPopover: ariaLabelPopover }));
};
//# sourceMappingURL=AdornmentDejarg.js.map